import { AlertService } from './../../services/alert.service';
import { Component, OnInit, Input } from '@angular/core';
import { EchangeDonneesConfiguration } from '../../../configuration/shared/classes/echange-donnees-configuration';
import { EchangeDonneesService } from '../../services/echange-donnees.service';
import { EchangeDonnees } from '../../classes/echange-donnees';
import { TRANSLATE } from '../../classes/translatable';

@Component({
  selector: 'app-echange-donnees',
  templateUrl: './echange-donnees.component.html',
  styleUrls: ['./echange-donnees.component.css']
})
export class EchangeDonneesComponent implements OnInit {

    @Input() roleId: string;

    configurations: Array<EchangeDonneesConfiguration> = [];
    echangeDonnees: EchangeDonnees;

    bureaux: Array<any> = [];
    selectedBureau: string;

    constructor(
        private echangeDonneesService: EchangeDonneesService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.fetchEchangeDonneesConfigurations();
        this.initEchangeDonnees();
    }

    get availableDomains() {
        return this.configurations.map(configuration => {
            if (configuration.domain !== '') {
                return configuration.domain;
            }
        });
    }

    initEchangeDonnees() {
        this.echangeDonnees = new EchangeDonnees({
            idEntiteLocal: this.roleId,
            entiteType: 'identite',
            domainDistant: ''
        });
    }

    fetchEchangeDonneesConfigurations() {
        this.echangeDonneesService.fetchConfigurations(true)
            .subscribe(response => {
                if (response.status === 200) {
                    this.configurations = response.data.map(configuration => {
                        return EchangeDonneesConfiguration.fromJson(configuration);
                    });
                }
            });
    }

    fetchBureauxByDomain(domain: string) {
        this.echangeDonneesService.fetchBureauxByDomain(domain)
            .subscribe(response => {
                if (response.status === 200) {
                    this.bureaux = response.data;
                }
            });
    }

    sendData() {
        this.echangeDonneesService.echange(this.echangeDonnees, this.selectedBureau)
            .subscribe(response => {
                if (response.status === 200) {
                    this.alertService.success(TRANSLATE('Données envoyées avec succès'));
                }
            });
    }

    onDomainChanged(domain: string) {
        this.bureaux = [];
        this.selectedBureau = null;
        this.fetchBureauxByDomain(domain);
    }
}
